import React, { FC, ReactNode, useState } from 'react';
import { ExcessReturnContext } from './context';
import { ExcessReturnsType } from 'pages/main-store/excess-returns';

const ExcessReturnProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [excessReturnToUpdate, setExcessReturnToUpdate] = useState<ExcessReturnsType | any>(null);
  return (
    <ExcessReturnContext.Provider
      value={{
        excessReturnToUpdate,
        setExcessReturnToUpdate
      }}>
      {children}
    </ExcessReturnContext.Provider>
  );
};

export default ExcessReturnProvider;
